import { InputNumber, Radio, Form, Input, Tooltip, Flex, message } from "antd";
import './index.less';
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@/utils";
import { formatDecimalWithZeros } from "@/utils";
import { cdnUrl } from '@/utils/cdn';

function ItemInput({ fee, otherTokenInfo, queryOtherTokenInfo, ...props }: any) {
  const { t } = useTranslation();
  return (
    <div className="input-unit">
      <div className="title">
        {fee === 0
          ?
          <Flex gap={2}>
            <span>{t("batchSwap.numberOfLoopExecutions")}</span>
            <Tooltip
              title={t("batchSwap.numberOfLoopExecutionsExplain")}
            >
              <img src={cdnUrl("/img/remind-icon.svg")} alt="" />
            </Tooltip>
          </Flex>
          :
          <>
            <Flex gap={2}>
              <span>{t("batchSwap.triggerStopRunningPrice")}</span>
              <Tooltip
                title={fee === 1 ? t("batchSwap.triggerStopRunningPriceExplain1") : t("batchSwap.triggerStopRunningPriceExplain2")}
              >
                <img src={cdnUrl("/img/remind-icon.svg")} alt="" />
              </Tooltip>
            </Flex>
            <div className="price">
              <span>{t("batchSwap.currentPrice", { symbol: otherTokenInfo.symbol, price: formatDecimalWithZeros(otherTokenInfo.price) })}</span>
              <div className="refresh">
                <img src={cdnUrl("/img/refresh.webp")} alt="" onClick={queryOtherTokenInfo} />
              </div>
            </div>
          </>
        }

      </div>
      {
        fee === 0 ? (
          <InputNumber
            min={1}
            max={2000}
            {...props}
            className={fee === -1 ? "jito-fee-input ant-input-number-selected" : "jito-fee-input"}
            defaultValue={1}
            controls={false}
            suffix={t("batchSwap.number")}
          />
        ) : (
          <Input {...props} />
        )
      }
    </div>
  );
}

export default function StopWay({ form, queryOtherTokenInfo, otherTokenInfo, isTokenANativeOrStable, isTokenBNativeOrStable }: any) {

  const fees = [0, 1, 2];
  const formFee = form.getFieldValue('stopType');
  const [fee, setFee] = useState(fees.includes(formFee) ? formFee : -1);
  const { t } = useTranslation();
  // const [currentPrice, setCurrentPrice] = useState(0);

  const options = [{
    label: t('batchSwap.runTimes'),
    value: 0
  }, {
    label: t('batchSwap.stopByUp'),
    value: 1
  }, {
    label: t('batchSwap.stopByDown'),
    value: 2
  }];

  useEffect(() => {
    form.setFieldsValue({ stopType: fee });
  }, [fee, form]);

  // useEffect(() => {
  //   getPrice();
  // }, [fee, tokenA, tokenB]);

  function renderOption() {
    return (
      <>
        {
          options.map((item: any, index: any) => {
            return (
              <Radio.Button className="cus-radio-button" value={item.value} key={index}>{t(item.label)}</Radio.Button>
            );
          })
        }
      </>
    );
  }

  function Item(props: any) {
    return (
      <Radio.Group
        className="sl-radio-btn-group"
        {...props}
        onChange={e => {
          console.log("e.target.value", e.target.value)
          if (isTokenBNativeOrStable && e.target.value == 1) {
            // 当前情况不能选择此项
            message.error(t("batchSwap.cannotSelectThisOption"))
            return
          }
          if (isTokenANativeOrStable && e.target.value == 2) {
            message.error(t("batchSwap.cannotSelectThisOption"))
            return
          }
          setFee(e.target.value);
        }}
        buttonStyle="solid"
      >
        {renderOption()}
      </Radio.Group>
    );
  }

  return (
    <div className="stop-way">
      <div className="jito-option-title">
        <span>{t("batchSwap.stopWay")}</span>
        <Tooltip
          title={t("batchSwap.stopWayExplain")}
        >
          <img src={cdnUrl("/img/remind-icon.svg")} alt="" />
        </Tooltip>
      </div>
      <Form.Item
        className="mix-form-item"
        shouldUpdate={(prevValues, currentValues) => prevValues.stopType !== currentValues.stopType}
      >
        {() => (
          <div className="jito-option-body">
            <Form.Item
              label={null}
              name="stopType"
            >
              <Item />
            </Form.Item>
            <Form.Item
              label={null}
              name="stopInput"
            >
              <ItemInput
                fee={fee}
                otherTokenInfo={otherTokenInfo}
                queryOtherTokenInfo={queryOtherTokenInfo}
              />
            </Form.Item>
          </div>
        )}
      </Form.Item>
    </div>
  );
}
